import type { OrderDeliveryAddress, OrderPaymentData } from "../../types/purchaseOrder/Order";

/**
 * Forma del formulario "Actualizacion de datos". Reusa las claves de
 * OrderPersonalInformationFields / OrderDeliveryAddressFields del checkout para poder
 * reutilizar sus componentes hoja (AddressFields, etc.) sin cambios.
 */
export interface ActualizacionDatosDatosPersonales {
    mail: string;
    tinCodDocumentoTipo: number | null;
    documento: string | null;
    nombre: string | null;
    apellido: string | null;
    vchCuit: string | null;
    vchRazonSocial: string | null;
    tinCodAfipResponsableTipo: number | null;
    codigoArea: string | null;
    telefono: string | null;
}

export type ActualizacionDatosFormValues = {
    datosPersonales: ActualizacionDatosDatosPersonales;
    domicilioFacturacion: OrderDeliveryAddress;
    mismoDomicilioInstalacion: boolean;
    domicilioInstalacion: OrderDeliveryAddress;
    idPagoOpcion: string | null;
    datosPago: OrderPaymentData | null;
};

export const ACTUALIZACION_DATOS_FIELDS = {
    DatosPersonales: "datosPersonales",
    DomicilioFacturacion: "domicilioFacturacion",
    MismoDomicilioInstalacion: "mismoDomicilioInstalacion",
    DomicilioInstalacion: "domicilioInstalacion",
    IdPagoOpcion: "idPagoOpcion",
    DatosPago: "datosPago",
} as const;

export const domicilioVacio = (): OrderDeliveryAddress => ({
    calle: null,
    calleNro: null,
    pisoDpto: null,
    codigoPostal: "",
    codProvincia: null,
    descLocalidad: null,
    barrioPrivado: false,
    nombreBarrio: null,
    lote: null,
});

export const ACTUALIZACION_DATOS_DEFAULT_VALUES: ActualizacionDatosFormValues = {
    datosPersonales: {
        mail: "",
        tinCodDocumentoTipo: null,
        documento: null,
        nombre: null,
        apellido: null,
        vchCuit: null,
        vchRazonSocial: null,
        tinCodAfipResponsableTipo: null,
        codigoArea: null,
        telefono: null,
    },
    domicilioFacturacion: domicilioVacio(),
    mismoDomicilioInstalacion: true,
    domicilioInstalacion: domicilioVacio(),
    idPagoOpcion: null,
    datosPago: null,
};

/** Payload que espera VodaActualizacionDatosController (camelCase, 1:1 con el DTO backend). */
export interface VodaActualizacionDatosDomicilioPayload {
    calle: string | null;
    calleNro: string | null;
    pisoDpto: string | null;
    codProvincia: number | null;
    provincia: string | null;
    descLocalidad: string | null;
    codigoPostal: string | null;
    barrioPrivado: boolean;
    nombreBarrio: string | null;
    lote: string | null;
}

export interface VodaActualizacionDatosPayload {
    mail: string;
    tinCodDocumentoTipo: number | null;
    documentoTipoDesc: string | null;
    nroDocumento: string | null;
    nombre: string | null;
    apellido: string | null;
    cuit: string | null;
    razonSocial: string | null;
    sinCodAfipResponsableTipo: number | null;
    afipResponsableTipoDesc: string | null;
    codigoArea: string | null;
    telefono: string | null;
    domicilioFacturacion: VodaActualizacionDatosDomicilioPayload;
    mismoDomicilioInstalacion: boolean;
    domicilioInstalacion: VodaActualizacionDatosDomicilioPayload | null;
    idPagoOpcion: string | null;
    formaPagoDesc: string | null;
    codPagoProveedor: number | null;
    datosTarjeta: {
        nombreTitular: string | null;
        codTarjetaTipo: number | null;
        tarjetaTipoDesc: string | null;
        numero: string | null;
        fechaVto: string | null;
    } | null;
    cbu: string | null;
}
